export const isCustom = (hospitalId: number) => {
  return hospitalId === 138 || hospitalId === 1 || hospitalId === 45;
};

export const DIRECT_PRICE = 6_000_000;
